<p class="login-text">
  <ng-content></ng-content>
  <button (click)="loginBackend()" class="mt-10">Login</button>
</p>
